import type { GoOfflineConfig } from "../types";
import { normalizeConfig } from "../utils/normalize-config";
import { serviceWorkerSource } from "./sw-runtime";

export function createServiceWorkerTemplate(config: GoOfflineConfig = {}): string {
  const resolved = normalizeConfig(config);

  return `self.__GO_OFFLINE_BOOTSTRAP__ = ${JSON.stringify(
    {
      version: resolved.version,
      offlinePage: resolved.offlinePage,
      offlineImage: resolved.offlineImage,
      precache: resolved.precache,
      runtimeCaching: resolved.runtimeCaching,
      debug: resolved.debug
    },
    null,
    2
  )};\n${serviceWorkerSource.replace(
    'let runtimeConfig = { ...DEFAULT_CONFIG };',
    "let runtimeConfig = { ...DEFAULT_CONFIG, ...(self.__GO_OFFLINE_BOOTSTRAP__ || {}) };"
  )}\n`;
}
